import Repository from './Repository'
const resource = '/ea_companies'

export default {
  /**
   * 元付け業者一覧情報を取得する
   * @param {String} name 元付業者名
   * @param {String} tel 元付業者電話番号
   * @param {Number} page ページ
   * @param {Number} perPage 取得件数
   */
  async get(name, tel, page, perPage) {
    const params = { name: name, tel: tel, page: page, per_page: perPage }
    return await Repository.get(`${resource}`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 元付け業者情報を取得する
   * @param {Number} id 元付け業者ID
   */
  async getOne(id) {
    return await Repository.get(`${resource}/${id}`)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
}
